import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
function StepCheckIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'AccentGreen', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: [_jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z", fill: primaryFillColor }), _jsx("path", { d: "M6 12.371l1.2-1.285L10 13.4 16.8 8 18 9.286 10 17l-4-4.629z", fill: "#fff" })] }));
}
export default StepCheckIcon;
//# sourceMappingURL=StepCheck.js.map